import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import AnexoButton from "../../../../../components/AnexoButton";
import { Anexo } from "../../../../../interfaces/entities/Reembolso/Anexo";
import { PendenciaCardProps } from "../../../../../interfaces/props/Financeiro/Reembolso/PendenciaCardProps";
import { ReanaliseReembolsoValidation } from "../../../../../interfaces/validation/Reembolso/ReanaliseReembolsoValidation";
import { sxButton, sxInput, sxLabel, sxStartAdornment, sxValidationMessage } from '../sxProps';
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";

const PendenciaCard = (props: PendenciaCardProps) => {
  const { reembolso, solicitarReembolso, acessoReanalise } = props;

  const accessibility = useAccessibility();

  const [anexos, setAnexos] = useState<Array<Anexo>>([]);

  const formik = useFormik({
    initialValues: {
      valor: '',
      motivo: ''
    },
    validationSchema: ReanaliseReembolsoValidation,
    onSubmit: (values) => {
      onSubmit(values);
    },
    validateOnChange: false
  });

  const onSubmit = (values: any) => {
    solicitarReembolso(anexos, parseInt(reembolso?.idPedidoReembolso || "0"), values.valor, values.motivo);
  };

  const salvarAnexos = (Anexos: Array<Anexo>) => {
    setAnexos(Anexos);
  };

  const handleCost = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const digits = value.replace(/^0+/, '');
    const noDot = digits.replace(/\./g, '');
    const onlyDigits = noDot.replace(/[^\d]/g, '');
    // If there are no digits, return an empty string
    if (onlyDigits.length === 0 || onlyDigits === '0') {
      formik.setFieldValue('valor', '');
    }
    else if (onlyDigits.length === 1) {
      formik.setFieldValue('valor', `0.0${onlyDigits}`);
    }

    else if (onlyDigits.length === 2) {
      formik.setFieldValue('valor', `0.${onlyDigits}`);
    }

    // Add the decimal point in the correct position
    else {
      let mask = '';
      const len = onlyDigits.length;
      for (let i = 0; i < len; i++) {
        mask += onlyDigits[i];
        if ((len - i) === 3 && i !== len - 1) {
          mask += '.';
        }
      }
      formik.setFieldValue('valor', mask);
    }

  }

  return (
    <div>
      <div className='margin-bottom-20'>
        <h2 className='title-detalhe-card'>Pendência</h2>
      </div>
      <div className="registration-data-card-holder margin-bottom-20">
        <div className="registration-data-card-service" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
          <div className="registration-data-row">
            <span className="registration-data-title" style={accessibility.textStyleAccessibility}>Dados do beneficiário(a)</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Nome</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.nomeBeneficiario}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Protocolo</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.codProtocAns}</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Data da solicitação</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.dtPedido}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Descrição da pendência</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.pendenciaOuvidor}</span>
          </div>
        </div>
      </div>
      {acessoReanalise === 'S' &&
        < form onSubmit={formik.handleSubmit} className='form-container-reembolso-detalhe'>
          <div className='margin-bottom-20'>
            <span className='info-detalhe-reembolso' style={accessibility.textStyleAccessibility}>
              Para solicitar a reanálise, justifique abaixo e, se necessário, anexe novos documentos.
            </span>
          </div>
          <div className='width-100'>
            <div className='width-100 margin-bottom-20'>
              <Typography sx={sxLabel} style={accessibility.textStyleAccessibility}>Valor pago</Typography>
              <OutlinedInput
                fullWidth
                type={'text'}
                value={formik.values.valor}
                onChange={handleCost}
                name='cost'
                maxRows={1}
                inputProps={{ maxLength: 15 }}
                placeholder="Digite o valor pago"
                startAdornment={formik.values.valor === '' ? null : <InputAdornment sx={sxStartAdornment} position="start">R$</InputAdornment>}
                sx={sxInput}
              />
              {
                formik.errors.valor &&
                <div className='container-validation-message'>
                  <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
                  <Typography id='errUserName' sx={sxValidationMessage} >{formik.errors.valor}</Typography>
                </div>
              }
            </div>


            <div className='width-100 margin-bottom-20'>
              <Typography sx={sxLabel} style={accessibility.textStyleAccessibility}>Motivo do atendimento particular</Typography>
              <OutlinedInput
                fullWidth
                type={'text'}
                value={formik?.values?.motivo}
                placeholder='Motivo do atendimento particular'
                onChange={formik.handleChange}
                name='motivo'
                error={!!formik.errors.motivo}
                multiline
                maxRows={5}
                style={{ height: '130px' }}
              />
              {formik.errors.valor &&
                <div className='container-validation-message'>
                  <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
                  <Typography id='errUserName' sx={sxValidationMessage} >{formik.errors.motivo}</Typography>
                </div>
              }
            </div>
          </div>
          <div>
            <div className='margin-bottom-20'>
              <span className='info-detalhe-reembolso' style={accessibility.textStyleAccessibility}>Anexe exames ou documentos na solicitação:</span>
            </div>
            <div className='margin-bottom-20'>
              <AnexoButton salvarAnexos={salvarAnexos} anexos={anexos}/>
            </div>
            <div className='margin-bottom-20'>
              <span className='info-detalhe-reembolso' style={accessibility.textStyleAccessibility}>Você pode anexar arquivos .pdf, .jpg, .doc e .png de até 4mb, sendo de notas fiscais/recibos, pedidos médicos, relatórios médicos, entre outros.</span>
            </div>
            <div className='margin-bottom-20'>
              <span className='info-detalhe-reembolso' style={accessibility.textStyleAccessibility}><b>Importante:</b> Somente serão válidos documentos como: nota fiscal, recibo com descrição do(s) serviço(s) prestado(s) e relatório médico.</span>
            </div>
          </div>
          <div>
            <Button type='submit' sx={sxButton} variant='contained'><b>SOLICITAR REANÁLISE</b></Button>
          </div>
        </form>
      }
    </div >
  )
}

export default PendenciaCard